import React, { useMemo, Fragment, useEffect, useState, useRef, useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { MaterialReactTable } from 'material-react-table';
import { useOutletContext } from 'react-router-dom';

const AccountAdminsDialog = ({ open, setOpen, accountAdminListFromAPI, accountAdminTableData, setAccountAdminTableData }) => {
    const {refClientAccountCmsData}=useOutletContext();
    const tableInstanceRef = useRef(null);

    /**
     *  /**
        adminId: "5d9c763a-f682-4ccf-ad24-fd4c9e825c7a"
        emailAddress: "sampletest1@manpowergroup.com"
        firstName: "Gayathri"
        lastName: "Karanam"
        permissionRole: "Admin"
        permissionRoleDescription: "Admin"
     */

        const fetchAccountAdminCmsData = (key) => {
            if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["ClientAccounts.AccountAdmins"]) {
                const adminClientSubAccountCmsDataLabel = refClientAccountCmsData?.Components["ClientAccounts.AccountAdmins"];
                return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key)
            }
            return '';
        }
        const fetchCommonComponentCMSLabel = (key) => {
            if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["CommonComponent"]) {
                const commonComponentLabel = refClientAccountCmsData?.Components["CommonComponent"];
                return returnLabel(commonComponentLabel?.Labels, key)
            }
            return '';
        }
    
        const returnLabel = (labelArray = [], key) => {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
        }

    const columns = useMemo(
        () => [
            {
                accessorFn: (row) => `${row.firstName} ${row.lastName}`,
                header:fetchAccountAdminCmsData('AccountAdmins.Name'),
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchAccountAdminCmsData("AccountAdmins.PlaceholderName") }
            },
            {
                accessorKey: "emailAddress",
                header: fetchAccountAdminCmsData('AccountAdmins.Email'),
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchAccountAdminCmsData("AccountAdmins.PlaceholderEmail") }
            },
            {
                accessorFn: (row) => `${row.permissionRole}`,
                header: fetchAccountAdminCmsData('AccountAdmins.PermissionLevel'),
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchAccountAdminCmsData("AccountAdmins.PlaceholderPermissionLevel") }
            },
        ],
        []
    );

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
        /**clear selections */
        setRowSelection({})
    }

    //optionally, you can manage the row selection state yourself
    const [rowSelection, setRowSelection] = useState({});

    const handleAddList = () => {
        /**get list of selected objects */
        const selectedRowObjList = tableInstanceRef.current
            .getSelectedRowModel()
            .rows.map((eachSelectedRowModel) => {
                return eachSelectedRowModel.original
            });
        setAccountAdminTableData([...accountAdminTableData, ...selectedRowObjList])

        // console.log("gl-sub:", selectedRowObjList)
        handleClose()
    }

    /**getting Ids of all exisitng entries to disable their selection */
    const [existingIds, setExistingIds] = useState([])
    useEffect(() => {
        if (!!accountAdminTableData) {
            const list = accountAdminTableData.map((item) => {
                return item.adminId
            })
            setExistingIds(list)
        }
    }, [accountAdminTableData])



    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown
            fullScreen
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
               {fetchAccountAdminCmsData('AccountAdmins.AddAccountAdmins')}
                <IconButton
                    sx={{ ml: 'auto' }}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <MaterialReactTable
                    tableInstanceRef={tableInstanceRef}
                    columns={columns}
                    data={accountAdminListFromAPI}
                    initialState={{
                        density: 'compact',
                        showColumnFilters: true
                    }}
                    enableRowSelection={(row) => {
                        // console.log("roe", row.original)
                        return !existingIds.includes(row.original.adminId)
                    }}
                    getRowId={(originalRow) => originalRow.adminId}
                    onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                    state={{ rowSelection }}
                    enableStickyHeader
                    muiTablePaginationProps={{
                        labelRowsPerPage: fetchCommonComponentCMSLabel('Common.Rowsperpage')
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: fetchAccountAdminCmsData('AccountAdmins.Actions'),
                        },
                    }}
                />

            </DialogContent>
            <DialogActions>
                <Button type='button' onClick={() => {
                    handleAddList()
                }}>{fetchCommonComponentCMSLabel('Common.Add')}</Button>
                <Button onClick={handleClose}>{fetchCommonComponentCMSLabel('Common.Cancel')}</Button>
            </DialogActions>

        </Dialog>
    )
}
export default AccountAdminsDialog